const labelsValidationPT = {
    "name": {
        "required": "Nome do selo é obrigatório",
        "unique": "Ops! Este selo já existe e é de propriedade de outro usuário. Por favor, tente outro nome de selo. Se você possui legalmente este nome de selo e detém os direitos autorais do nome, entre em contato com nossa equipe de suporte.",
        "available": "Nome do selo está disponível",
        "invalid": "Nome do selo é inválido"
    },
    "year": {
        "required": "Ano de fundação é obrigatório",
        "numeric": "O valor não é um número",
        "stringLength": "Ano de fundação deve ter 4 dígitos"
    },
    "releaseCatalog": {
        "required": "Lançamentos no catálogo são obrigatórios",
        "numeric": "O valor não é um número"
    },
    "logo": {
        "required": "O logotipo é obrigatório",
        "dimensions": "O tamanho do logotipo do selo deve ser 1000 x 1000 px, JPG/JPEG/PNG.",
        "choose": "Por favor, escolha uma imagem",
        "file": "Por favor, carregue formatos JPG ou PNG, resolução mínima 1000x1000px. Tamanho máximo 2MB"
    },
    "promo_graphic": {
        "dimensions": "O tamanho do gráfico promocional do selo deve ser 960 x 150 px, JPG/JPEG/PNG.",
        "choose": "Por favor, escolha uma imagem",
        "file": "Carregue formatos JPG ou PNG, resolução mínima 960x150px"
    }
};

export default labelsValidationPT;